import React from 'react'
import PropTypes from 'prop-types'

const Panel = (props) => {
  const activeClass = (tabName) => {
    return props.currentTab == tabName ? 'active' : ''
  } 

  return <div className={'league-panel' + (props.shortened ? ' shortened' : '')}>
    <button className={activeClass('Teams')} onClick={() => props.changeTab('Teams')}>Teams</button>
    <button className={activeClass('Games')} onClick={() => props.changeTab('Games')}>Games</button>
    <button className={activeClass('Standings')} onClick={() => props.changeTab('Standings')}>Standings</button>
    <button className={activeClass('Payments')} onClick={() => props.changeTab('Payments')}>Payments</button>
    <button className={activeClass('Players')} onClick={() => props.changeTab('Players')}>Players</button>
  </div>
}

Panel.propTypes = {
  shortened: PropTypes.bool,
  currentTab: PropTypes.string.isRequired,
  changeTab: PropTypes.func.isRequired,
}

export default Panel
